import { Colors } from "@/enums/Colors";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { SmallUserDTO } from "@/models/SmallUserDTO";
import { TinyUser } from "@/types/TinyUser";
import { Box, SxProps, Tooltip } from "@mui/material";
import { CSSProperties } from "react";

const AvatarSx: SxProps = {
  textTransform: "none",
  overflow: "hidden",
  borderRadius: "4px",
  width: "2.5rem",
  height: "2.5rem",
  objectFit: "cover",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: Colors.LAZO_PURPLE_DCAFFF,
  backgroundImage: `linear-gradient(160deg, ${Colors.BUTTON_PURPLE}, transparent)`,
  color: "#fff",
  fontSize: "1.3rem",
};

const PendingBadgeSx: SxProps = {
  position: "absolute",
  top: "-2px",
  right: "-2px",
  minWidth: "0.625rem",
  height: "0.625rem",
  borderRadius: "50%",
  backgroundColor: Colors.STATUS_WARNING_ICON,
  border: `1.5px solid ${Colors.WHITE}`,
  pointerEvents: "none",
};

export interface AvatarProps {
  sx?: SxProps;
  style?: CSSProperties;
  onlyFirstLetter?: boolean;
  user: User | TinyUser | SmallUserDTO;
  // LAZ-2053: when true, render a small badge over the avatar to indicate
  // the assignee has not yet accepted their invitation.
  pending?: boolean;
}

function UserAvatar({ sx, style, user, onlyFirstLetter, pending }: AvatarProps) {
  const avatar = (
    <Box sx={[AvatarSx, ...(Array.isArray(sx) ? sx : [sx])]} style={{ ...style }}>
      {user?.firstName?.[0]}
      {!onlyFirstLetter && user?.lastName?.[0]}
    </Box>
  );
  if (!pending) {
    return avatar;
  }
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      {avatar}
      <Tooltip title="Pending user — invitation not yet accepted" arrow>
        <Box sx={PendingBadgeSx} aria-label="Pending user" data-testid="pending-user-badge" />
      </Tooltip>
    </Box>
  );
}

export default UserAvatar;
